import Vue from 'vue'
import VueRouter from 'vue-router'
import homePage from '@/views/homePage'
import companyProfile from '@/views/companyProfile'
import serviceContent from '@/views/industrialChain/serviceContent'
import digitalMarketing from '@/views/industrialChain/digitalMarketing'
import ITSolutions from '@/views/industrialChain/ITSolutions'
import software from '@/views/softwareProduct/software'
import pricePage from '@/views/softwareProduct/pricePage'
import companyNews from '@/views/dynamicNews/companyNews'
import newsDetails from '@/views/dynamicNews/newsDetails'
import jobOpportunities from '@/views/jobOpportunities'
import contactUs from '@/views/contactUs'
import brandCustomers from '@/views/brandCustomers'
import commonProblem from '@/views/commonProblem'
import downloadCenter from '@/views/downloadCenter'
import privacyPolicy from '@/views/privacyPolicy'
import authcode from '@/views/authcode'

// 后台管理
import login from '@/views/admin/login/login'

// import config from '@/config'
// const title = config.title
Vue.use(VueRouter)

const routes = [
    {
        path: '*',
        redirect: '/'
    },
    {
        path: '/',
        name: 'pageView',
        component: () => import('@/views/pageView'),
        children: [
            {
                path: '/',
                redirect: '/homePage'
            },
            {
                path: '/homePage', //首页
                name: 'homePage',
                component: homePage,
            },
            {
                path: '/companyProfile', //关于我们  公司简介
                name: 'companyProfile',
                component: companyProfile,
            },
            {
                path: '/industrialChain',//产业链
                name: 'industrialChain',
                component: () => import('@/views/industrialChain/industrialChain'),
                children: [
                    {
                        path: '/industrialChain/serviceContent',  //服务内容 店铺运营
                        name: 'serviceContent',
                        component: serviceContent,
                    },
                    {
                        path: '/industrialChain/digitalMarketing',  //数字营销
                        name: 'digitalMarketing',
                        component: digitalMarketing,
                    },
                    {
                        path: '/industrialChain/ITSolutions',  //IT解决方案
                        name: 'ITSolutions',
                        component: ITSolutions,
                    },
                ]
            },
            {
                path: '/softwareProduct', //软件产品
                name: 'softwareProduct',
                component: () => import('@/views/softwareProduct/softwareProduct'),
                children: [
                    {
                        path: '/softwareProduct/software',  //软件产品
                        name: 'software',
                        component: software,
                    },
                    {
                        path: '/softwareProduct/pricePage',  //价格
                        name: 'pricePage',
                        component: pricePage,
                    }
                ],
            },
            {
                path: '/dynamicNews',//新闻动态
                name: 'dynamicNews',
                component: () => import('@/views/dynamicNews/dynamicNews'),
                children: [
                    {
                        path: '/dynamicNews/companyNews',  //公司新闻
                        name: 'companyNews',
                        component: companyNews,
                    },
                    {
                        path: '/dynamicNews/newsDetails',  //新闻详情
                        name: 'newsDetails',
                        component: newsDetails,
                    },

                    {
                        path: '/dynamicNews/companyNews',  //行业新闻
                        name: 'companyNews',
                        component: companyNews,
                    },
                ]
            },
            {
                path: '/jobOpportunities', //工作机会
                name: 'jobOpportunities',
                component: jobOpportunities,
            },
            {
                path: '/contactUs', //联系我们
                name: 'contactUs',
                component: contactUs,
            },
            {
                path: '/brandCustomers', //合作伙伴
                name: 'brandCustomers',
                component: brandCustomers,
            },

        ]
    },
    {
        path: '/commonProblem', //常见问题
        name: 'commonProblem',
        component: commonProblem,
    },
    {
        path: '/privacyPolicy', //隐私政策
        name: 'privacyPolicy',
        component: privacyPolicy,
    },
    {
        path: '/downloadCenter', //下载中心
        name: 'downloadCenter',
        component: downloadCenter,
    },
    {
        path: '/admin',
        name: 'admin',
        component: () => import('@/views/admin/adminLoginView'),
        children: [
            {
                path: '/admin', //首页
                name: 'admin',
                component: () => import('@/views/admin/admin'),
                children: [
                    {
                        path: '/admin',
                        redirect: '/admin/downloadCenter'
                    },
                    {
                        path: '/admin/carouselChart', //轮播图信息
                        name: 'carouselChart',
                        component: () => import('@/views/admin/carouselChart'),
                    },
                    {
                        path: '/admin/contactUs', //联系我们信息
                        name: 'contactUs',
                        component: () => import('@/views/admin/contactUs'),
                    },
                    {
                        path: '/admin/jobWantedInfo', //求职者信息
                        name: 'jobWantedInfo',
                        component: () => import('@/views/admin/jobWantedInfo'),
                    },
                    {
                        path: '/admin/newsInfo', //动态新闻信息
                        name: 'newsInfo',
                        component: () => import('@/views/admin/newsInfo'),
                    },
                    {
                        path: '/admin/recruitInfo', //招聘信息
                        name: 'recruitInfo',
                        component: () => import('@/views/admin/recruitInfo'),
                    },
                    {
                        path: '/admin/commonProblem', //常见问题信息
                        name: 'commonProblem',
                        component: () => import('@/views/admin/commonProblem'),
                    },
                    {
                        path: '/admin/developmentHistory', //发展历程
                        name: 'developmentHistory',
                        component: () => import('@/views/admin/developmentHistory'),
                    },
                    {
                        path: '/admin/companyInfo', //企业信息
                        name: 'companyInfo',
                        component: () => import('@/views/admin/companyInfo'),
                    },
                    {
                        path: '/admin/downloadCenter', //下载中心
                        name: 'downloadCenter',
                        component: () => import('@/views/admin/downloadCenter'),
                    }
                ],
                async beforeEnter(to, form, next) {//
                    // console.log(store.state.loginUser,'be');
                    // console.log(store.state.loginUser.data,'be')
                    // console.log(to)
                    // console.log(form)
                    // console.log(next)
                    // if(to.meta.title){
                    //   document.title = to.meta.title;
                    // }
                    if (localStorage.getItem("token")) {
                        // if(store.state.loginUser.data){
                        next();
                        // }else{
                        //   let resp = await store.dispatch("loginUser/whoAmI");
                        //   if(resp){
                        //     next();
                        //   }else{
                        //     next("/login");
                        //   }
                        // }
                    } else {
                        next("/login");
                    }
                }
            },
            {
                path: '/login', //登入
                name: 'login',
                component: login,
            },
        ],

    },
    {
        path: '/authcode', //新页面，获取url数据
        name: 'authcode',
        component: authcode,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
